// extracted by mini-css-extract-plugin
export default {"root":"N1tHvwchN9qJCHr3Zvvx","version-data":"hdxZhWyPQCs7lzlv54Gw","versionData":"hdxZhWyPQCs7lzlv54Gw","offset":"CAxblsx4VMG8KNwn3Fhi"};